module.exports = __webpack_public_path__ + "static/media/stepOneActive.c73784df.png";